import { Box, Popover, Typography, Tooltip } from "@material-ui/core";
import React, { useRef, useState } from "react";
import { get } from "lodash";
import useStyles from "./styles";
import UserProfileWidget from "../../widgets/UserProfileWidget";
import { checkArrayLength } from "../../../utils";
import { useTranslation } from "react-i18next";
import {
  COACH_FIRSTNAME,
  COACH_ID,
  COACH_LASTNAME,
} from "../../../constants/literalConstant";
import StarIcon from "Assets/images/grey-star.svg";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

const CoachesList = ({ userList, label }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const containerRef = useRef();

  const displayUserList = (res, key) => {
    let star = null;
    if (get(res, "role", "") === "Coach" && get(res, "leadReviewer", false)) {
      star = <img src={StarIcon} />;
    } else if (get(res, ".role", "") === "Coach") {
      star = "";
    }
    return (
      <Tooltip title={get(res, COACH_FIRSTNAME, "")} key={key}>
        <Box
          display="flex"
          className={`${classes.coacheeList} ${
            get(res, "role", "") === "Coach" ? classes.profileBorder : ""
          } position-relative`}
          key={key}
          alignItems="center"
        >
          <UserProfileWidget
            userId={get(res, COACH_ID, false) || get(res, "coachid", "")}
            firstName={get(res, COACH_FIRSTNAME, "")}
            lastName={get(res, COACH_LASTNAME, "")}
            url={
              get(res, "coach.profileImage.fileName", "") ||
              res?.coach?.profileImage
            }
          />
          <span className={classes.star}>{star}</span>
          <Box width="80%" textAlign="left">
            <Box display={"block"}>
              <Typography variant="body2" className="font-13" noWrap="true">
                {`${get(res, COACH_FIRSTNAME, "")} ${get(
                  res,
                  COACH_LASTNAME,
                  ""
                )}`}
              </Typography>
              <Typography
                variant="body2"
                noWrap="true"
                className="font-12 font-light f-gray"
              >
                {get(res, "display", "")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Tooltip>
    );
  };

  return (
    <>
      <Box
        data-testid="handleClick"
        inputProps={{ "data-testid": "handleClick" }}
        className={`${classes.coachInfo} coach-info`}
        aria-describedby={id}
        onClick={handleClick}
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginTop="10px"
        color="#07519C"
        fontSize="13px"
        font="normal normal normal 13px/18px Poppins"
      >
        {/* <Avatar className={`${classes.showMore} cursor-pointer`}>
          <MoreHorizOutlined color="primary" />
        </Avatar> */}
        <span className="font-12 cursor-pointer">
          {label ? label : `${checkArrayLength(userList)}+`}
        </span>
      </Box>
      <Popover
        data-testid="handleClose"
        container={containerRef.current}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box className={classes.listWrapper} py={1}>
          <SimpleBar
            forceVisible="y"
            style={{ maxHeight: 400 }}
            data-simplebar-auto-hide="false"
          >
            {userList.map((res, index) => {
              return displayUserList(res, index);
            })}
          </SimpleBar>
        </Box>
      </Popover>
    </>
  );
};

export default CoachesList;
